import template from './am-assets-list-table.html';
import { AmSelectListController } from '../am-list-table-base.controller';
import { getTableRow } from '../../../../functions/table.functions';
import { ordersBy } from '../../core/models/am-helper.model';

class AmAssetListTableController extends AmSelectListController {
  constructor(amAssignmentService) {
    'ngInject';

    super();
    this.assignmentStatus = amAssignmentService.assignmentStatus;
  }

  $onInit() {
    this.onSelection = this.onSelection || undefined;
    this.tableRows = this.tableRows || this.getDefaultTableRows();
    // if sortedBy not supplied will default the sorting on codesSyncStatus (assignment status)
    // and enable the filtering by ng-repeat
    if (!this.sortedBy) {
      this.useSortExpr = true;
      this.sortedBy = ordersBy.codesSyncStatus;
    }
  }

  // build sort expression to use in ng-repeat for spots where we are not using the service for client side filtering
  get sortExpr() {
    return this.useSortExpr ? `${this.sortedBy.desc ? '-' : '+'}${this.sortedBy.attr}` : undefined;
  }

  toggelSelectAsset(asset, event) {
    if (asset.unselectable) return;
    this.toggelSelection(asset, event);
  }

  getDefaultTableRows() {
    return [
      getTableRow({
        header: 'Name',
        valueIsClickable: !this.selectMode,
        valueOnClick: (obj) => this.onViewAsset(obj),
        getRowClass: () => (this.selectMode ? '' : { linkable: true }),
      }),
      getTableRow({
        header: 'Make',
      }),
      getTableRow({
        header: 'Model',
      }),
      getTableRow({
        header: 'Year',
      }),
      getTableRow({
        header: 'Keypad Connected',
        value: (prop) => (prop.keypadStatus ? 'Yes' : 'No'),
      }),
      getTableRow({
        header: 'Current Session',
        show: () => this.selectMode === false,
        value: (prop) => (prop.accessSession ? 'Checked In' : 'Checked Out'),
      }),
      getTableRow({
        header: 'Assignment Status',
        headerIsClickable: true,
        headerOnClick: () => this.sortByColumn('codesSyncStatus'),
        getHeaderClass: () => ({
          clickable: true,
          'text-bold': this.sortedBy && this.sortedBy.attr === 'codesSyncStatus',
        }),
        sortable: () => this.sortedBy && this.sortedBy.attr === 'codesSyncStatus',
        sortIcon: () => this.sortDirIcon,
        value: (prop) => this.getAssignmentStatusFromAsset(prop).label,
        icon: true,
        getIcon: (prop) => this.getAssignmentStatusFromAsset(prop).iClass,
      }),
    ];
  }

  getAssignmentStatusFromAsset({ codesSyncStatus }) {
    const maybeAssignmentStatus = this.assignmentStatus[codesSyncStatus];
    return maybeAssignmentStatus || { label: '', iClass: '' };
  }

  sortByColumn(name) {
    const { attr: currentSortProp, desc: currentDir } = this.sortedBy || {};
    this.sortedBy = {
      attr: name,
      desc: name === currentSortProp && !currentDir,
    };
    if (this.onSort) {
      this.onSort({ sortByEvent: this.sortedBy });
    }
  }

  get sortDirIcon() {
    return this.sortedBy && this.sortedBy.desc ? 'z-arrowdown' : 'z-arrowup';
  }
}

export default {
  template,
  controller: AmAssetListTableController,
  controllerAs: 'assetsTbVm',
  bindings: {
    list: '<',
    tableRows: '<',
    onViewAsset: '&',
    selectMode: '<',
    selected: '=?',
    unSelectableList: '<',
    onSelection: '&',
    sortedBy: '<',
    onSort: '&',
  },
};
